/* eslint no-eval: 0 */
import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import Result from '../../base/result';
import { getSeriesFromCouples } from '../../../utils';
// import Box from '../../base/DragThingsToBoxes/Box';
import './index.less';
import { motion } from 'framer-motion';
import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import BoxBag from '../../base/DragThingsToBoxes/BoxBag';
import BoxC1 from '../../base/DragThingsToBoxes/BoxC1';
import BoxC5 from '../../base/DragThingsToBoxes/BoxC5';
import BoxC10 from '../../base/DragThingsToBoxes/BoxC10';
import ChangeOrientation from '../../Utils/ChangeOrientation';
import { t } from '../../../languages';
import moment from 'moment';
import BackMusic from '../../base/BackMusic';
import { getRandomMessage2 } from '../utils';

const CartoonLayOut = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        numberinbox: 0,
        message: null,
        message2: null,
        showresults: false,
        moved: 0,
    });

    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        return () => { };
    }, []);

    useEffect(() => {
        const params = props.params;
        const couples = params.couples;
        const series = getSeriesFromCouples(couples, params.num);
        const splitSerie = series[0].split(/(\+|-|\*|\/)/sg);

        setState((prevState) => ({
            ...prevState,
            series,
            numberinbox: parseInt(splitSerie[0]),
        }));
    }, [props.params]);

    const handleRate = () => {
        const { current, series, results, numberinbox } = state;
        const curr_serie = series[current];
        const currentNumber = eval(curr_serie);
        const current_result = currentNumber === numberinbox ? 1 : 0;

        const message =
            (current_result ? t(props.lang, 'rightanswer') : t(props.lang, 'wrong')) +
            `, ${curr_serie} ${t(props.lang, 'is')} ${currentNumber}`;
        const message2 = current_result
            ? t(props.lang, getRandomMessage2('great'))
            : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            results: [...results, current_result],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series } = state;

        if (current < series.length - 1) {
            const splitSerie = series[current + 1].split(/(\+|-|\*|\/)/sg);

            setState((prevState) => ({
                ...prevState,
                current: current + 1,
                numberinbox: parseInt(splitSerie[0]),
                message: null,
                message2: null,
                moved: 0,
            }));
        } else {
            const { params, uid, eid, saveResult } = props;
            const num = params.num;
            const hits = state.results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');


            saveResult(uid, `${uid}-${eid}`, { id: 'CL', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, r: state.results, s: series, et: elapsedTime, });

            setState((prevState) => ({
                ...prevState,
                showresults: true,
            }));
        }
    };

    const handleRepeat = () => {
        const params = props.params;
        const couples = params.couples;
        const series = getSeriesFromCouples(couples, params.num);
        const splitSerie = series[0].split(/(\+|-|\*|\/)/sg);

        setState({
            series,
            current: 0,
            numberinbox: parseInt(splitSerie[0]),
            results: [],
            message: null,
            message2: null,
            showresults: false,
            moved: 0,
        });
    };

    const handleMove = (items, box) => {
        const { series, numberinbox } = state;
        const currentSerie = series[state.current];
        const splitSerie = currentSerie.split(/(\+|-|\*|\/)/sg);
        const fn = splitSerie[0];
        const currentResponse = eval(currentSerie);
        const baseNum = fn >= 10 || currentResponse >= 10 ? 19 : 9;
        const number = items.reduce((acc, item) => acc + item.value, 0);

        if (box === 'bag') {
            setState((prevState) => ({
                ...prevState,
                numberinbox: baseNum - number,
                moved: 1,
            }));
        } else {
            setState((prevState) => ({
                ...prevState,
                numberinbox: numberinbox + number,
                moved: 1,
            }));
        }
    };

    const {
        current,
        series,
        results,
        numberinbox,
        message,
        message2,
        showresults,
        moved,
    } = state;

    const rows = props.params.rows;
    const lang = props.lang;
    const currentSerie = series[current];
    const splitSerie = currentSerie?.split(/(\+|-|\*|\/)/sg);
    const fn = splitSerie?.[0];
    const op = splitSerie?.[1];
    const currentNumber = op + splitSerie?.[2];
    const currentResponse = currentSerie ? eval(currentSerie) : null;
    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / series.length) * 100);
    const is_test = props.params.is_test ? props.params.is_test : false;
    const baseNum = (fn >= 10 || currentResponse >= 10) ? 19 : 9;
    const bagNumber = baseNum - fn;

    let bagItems = [];
    let restoBag = bagNumber;

    if (bagNumber >= 10) {
        bagItems.push({ uid: 6, value: 10, img: './static/board/c10.png', itemTarget: 'c10' });
        restoBag -= 10;
    }

    if (restoBag >= 5) {
        bagItems.push({ uid: 5, value: 5, img: './static/board/c5.png', itemTarget: 'c5' });
        restoBag -= 5;
    }

    if (restoBag < 5) {
        for (let idx = 0; idx < restoBag; idx++) {
            bagItems.push({ uid: idx, value: 1, img: './static/board/c1.png', itemTarget: 'c1' });
        }
    }

    const shouldAdd10 = fn >= 10;
    const tenthItem = shouldAdd10 ? [{ uid: 6, value: 10, img: './static/board/c10.png', itemTarget: 'c10' }] : null;
    const shoudAdd5 = (fn >= 10 && fn - 10 >= 5) || (fn < 10 && fn >= 5);
    const fifthItem = shoudAdd5 ? [{ uid: 5, value: 5, img: './static/board/c5.png', itemTarget: 'c5' }] : null;
    const restoNumber = fn - (shouldAdd10 ? 10 : 0) - (shoudAdd5 ? 5 : 0);

    const firstItem = restoNumber >= 1 ? [{ uid: 1, value: 1, img: './static/board/c1.png', itemTarget: 'c1' }] : null;
    const secItem = restoNumber >= 2 ? [{ uid: 2, value: 1, img: './static/board/c1.png', itemTarget: 'c1' }] : null;
    const thirdItem = restoNumber >= 3 ? [{ uid: 3, value: 1, img: './static/board/c1.png', itemTarget: 'c1' }] : null;
    const fourthItem = restoNumber >= 4 ? [{ uid: 4, value: 1, img: './static/board/c1.png', itemTarget: 'c1' }] : null;

    if (!showresults) {
        return (
            <Row className="exercise">
                <BackMusic source={'random'} />
                <ChangeOrientation to={'portrait'} />
                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}
                <Col span={24} className="exercise-body">
                    <ExerciseBlocker show={messagestyle} />
                    <section className={`cartoonlayout ${rows > 1 ? 'b10' : 'b5'}`} key={currentSerie}>
                        <div className="left">
                            <BoxBag id="bag" items={bagItems} onMove={handleMove} />
                        </div>
                        <div className="right">
                            <div>
                                <BoxC1 key={1} id="one" items={firstItem} onMove={handleMove} />
                                <BoxC1 key={2} id="one" items={secItem} onMove={handleMove} />
                                <BoxC1 key={3} id="one" items={thirdItem} onMove={handleMove} />
                                <BoxC1 key={4} id="one" items={fourthItem} onMove={handleMove} />
                            </div>
                            <div>
                                <BoxC5 key={5} id="five" itemTarget="c5" items={fifthItem} onMove={handleMove} className="five" />
                                {(fn >= 10 || currentResponse >= 10) && (
                                    <BoxC10 key={10} id="ten" itemTarget="c10" items={tenthItem} onMove={handleMove} className="ten" />
                                )}
                            </div>
                        </div>
                    </section>
                </Col>
                <Col span={24} className="">
                    {currentNumber ? <article className="number cartoon-specyfic" key={currentNumber}>
                        <motion.div
                            animate={{ scale: 3 }}
                            transition={{ duration: 1 }}
                            className="the-number"
                        >
                            {currentNumber}
                        </motion.div>
                    </article> : null}
                </Col>
                <Col span={24}>
                    <Row className={'botones' + messagestyle}>
                        <Col span={24} className={'message'}>
                            {message}
                        </Col>
                        {!message && (
                            <Col span={24}>
                                <Button
                                    key="submit"
                                    type="primary"
                                    onClick={handleRate}
                                    style={{ width: '90%' }}
                                    disabled={!moved}
                                >
                                    {t(props.lang, 'grade')}
                                </Button>
                            </Col>
                        )}
                        {message && (
                            <Col span={24}>
                                <Button key="submit" type="primary" onClick={handleNext} style={{ width: '90%' }}> {t(props.lang, 'next')}</Button>
                            </Col>
                        )}
                        {message2 && (
                            <Col span={24} className={'message'}>
                                {message2}
                            </Col>
                        )}
                    </Row>
                </Col>
            </Row>
        );
    } else {
        return (
            <Result params={props.params} results={results} handleRepeat={handleRepeat} handleCancel={props.handleCancel} lang={lang} />
        );
    }
};

export default CartoonLayOut;